import {Button, Checkbox, Tabs} from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import CreateResource from '../../components/CreateResource/CreateResource';
import FiltersForm from '../../components/FiltersForm/FiltersForm';
import Icon from '../../components/Icon/Icon';
import PublishedResourcesTab from './PublishedResourcesTab/PublishedResourcesTab';
import styles from './BackofficeResourceList.module.scss';
import UnpublishedResourcesTab from './UnpublishedResourcesTab/UnpublishedResourcesTab';
import { useBackofficeResourcesList } from './useBackofficeResourceList';
import SearchForm from '../../components/SearchForm/SearchForm';
import { useLocation } from 'react-router-dom';

const BackofficeResourceList = () => {
  const { TabPane } = Tabs;

  const { filterDefaultValues,
    filterFields,
    getFiltersAsQueryParams,
		onResetFilters,
		onSearchByTerm,
    onSubmitFilters, state, toggleAddResourcePopup, toggleMobileFilters } = useBackofficeResourcesList();
	const { activeFilters, showAddResourcePopup, showMobileFilters } = state;
	
	const location: any = useLocation();
	const { activeTab } = location.state || {};

	const intl = useIntl();

  const tabBarExtraContent = (
    <div className={styles.tabBarExtraContent}>
      <Button type="primary" size="large" onClick={toggleAddResourcePopup}>
        <FormattedMessage id="buttons.addResource" />
      </Button>
    </div>
  );

  return <div className={styles.pageContainer}>
		<div className={`${styles.pageSider} ${styles.topBorder}`}>
			<SearchForm searchByTermLabel={intl.formatMessage({id: "formPlaceholders.searchTitle"})} onSearchByTerm={onSearchByTerm}/>
      <FiltersForm
        fields={filterFields}
        defaultValues={filterDefaultValues}
        onResetFilters={onResetFilters}
        onSubmit={(filters) => onSubmitFilters(filters)} />
    </div>
    <div className={styles.pageContent}>
			<div className={styles.mobileTopper}>
				<SearchForm searchByTermLabel={intl.formatMessage({id: "formPlaceholders.searchTitle"})} onSearchByTerm={onSearchByTerm}/>
        <Button type="text" onClick={toggleMobileFilters} icon={<Icon color="black" name="sliders-h" />} />
      </div>
			<div className={styles.tabBarExtraContentMobile}>
				<Button type="primary" size="large" onClick={toggleAddResourcePopup}>
					<FormattedMessage id="buttons.addResource" />
				</Button>
			</div>
      <Tabs
        className={`navigator ${styles.content}`}
        defaultActiveKey= {activeTab || "1"}
				tabBarExtraContent={tabBarExtraContent}
				destroyInactiveTabPane
      >
        <TabPane
          key="1"
          tab={<>
					<span className={styles.tabNav}>
            <FormattedMessage id="navigation.publishedResources" />
					</span>
            <span className={styles.tabDivider}>/</span>
          </>}
        >
          <PublishedResourcesTab filters={getFiltersAsQueryParams(activeFilters)}/>
        </TabPane>
        <TabPane
          key="2"
          tab={<>
					<span className={styles.tabNav}>
            <FormattedMessage id="navigation.unpublishedResources" />
					</span>
          </>}
        >
          <UnpublishedResourcesTab filters={getFiltersAsQueryParams(activeFilters)}/>
        </TabPane>
      </Tabs>
    </div>
    {showAddResourcePopup && <CreateResource onClose={toggleAddResourcePopup} />}

    {/* Mobile filters */}
			<div className={`${styles.mobileFiltersBackdrop} ${showMobileFilters ? styles.open : ''}`}></div>
			<div className={`${styles.mobileFilters} ${showMobileFilters ? styles.open : ''}`}>
				<div className={styles.actions}>
					<Button onClick={toggleMobileFilters} type="link" style={{paddingRight: 0}}>
						<Icon
							color="text"
							height="16px"
							name="times"
							width="16px"
						/>
					</Button>
				</div>
				<FiltersForm
					fields={filterFields}
					defaultValues={filterDefaultValues}
					onResetFilters={() => onResetFilters(toggleMobileFilters)}
					onSubmit={(filters) => onSubmitFilters(filters, toggleMobileFilters)} />
			</div>
  </div>
}
export default BackofficeResourceList;